import React from 'react';
import { Result } from 'antd';
import { CloseCircleOutlined } from '@ant-design/icons';
import './style.scss';

interface InactiveCountyProps {
  countyName: string;
}

const InactiveCounty: React.FC<InactiveCountyProps> = ({ countyName }) => {
  return (
    <div className="inactive-county">
      <Result
        status="error"
        icon={<CloseCircleOutlined />}
        title="County Not Active"
        subTitle={`${countyName} County is not currently active in MyNJAppeal. Please contact your county administrator for more information.`}
      />
    </div>
  );
};

export default InactiveCounty;
